var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 14.0934H15.111V15.1112H0.888672V14.0934Z",
    fill: "#D0004B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59551 3.26233L1.69779 9.72462L1.47559 12.92L4.68444 12.9245L11.5422 6.49337L8.59551 3.26233Z",
    fill: "#D0004B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.973 3.46659L11.7508 1.06659C11.6516 0.959118 11.5136 0.895723 11.3674 0.890703C11.2213 0.885681 11.0792 0.939475 10.973 1.03992L9.33301 2.56884L12.2842 5.7777L13.9464 4.21764H13.9463C14.046 4.11965 14.1042 3.98717 14.1093 3.84744C14.1142 3.70771 14.0654 3.57143 13.973 3.46652L13.973 3.46659Z",
    fill: "#D0004B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f39dd09d4c4c7cda02f291ff88f475e.svg";
export { ForwardRef as ReactComponent };